import { Button } from "@blueprintjs/core";
import styled from "@emotion/styled";

export default styled(Button)`
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  padding: 6px 16px;
  text-wrap: nowrap;
`;
